import shortenLabelName from "./shortenLabelName";
import replaceZentaiToBasename from "./replaceZentaiToBasename";
import { isSafari } from 'react-device-detect';

function Table({ json, basename }) {
  // 実数値は小数点以下2桁まで表記
  const fixDigit = (val, i) => {
    if (i <= 1) {
      if (typeof val === 'string') {
        return shortenLabelName(replaceZentaiToBasename(val, basename))
      }
      return parseInt(val).toLocaleString()
    }

    // 出願状況の設問のときは2桁、それ以外は1桁を返す
    const digit = json.headerGroup && json.headerGroup.filter(h => h.children && h.children.includes("出願件数")).length > 0 ? 2 : 1
    return parseFloat(val).toFixed(digit)
  }
  const HeaderParent = (json) => {
    if (json.headerGroup !== undefined) {
      return (
        json.headerGroup.map(h => {
          if (h.hasOwnProperty("children")) {
            return <th colSpan={h.children.length} className="border border-solid px-4 py-2">{h.parent}</th>
          } else {
            return <th rowSpan={2} className="border border-solid px-4 py-2">{h.parent}</th>
          }
        })
      )
    } else {
      return ""
    }
  }
  const HeaderChildren = (json) => {
    const verticalTopStyle = isSafari ? "" : "[writing-mode:vertical-lr]"
    if (json.headerGroup !== undefined) {
      return (
        json.headerGroup.map((h, idx) => {
          if (h.hasOwnProperty("children")) {
            return h.children.map(c => {
              return <th className={"border border-solid px-4 py-2 " + verticalTopStyle} key={c + idx.toString()}>{ shortenLabelName(c)}</th>
            })
          } else {
            return ""
          }
        }).flat()
      )
    } else {
      return json.header.map( h => <th className={"border border-solid px-4 py-2 " + verticalTopStyle} key={h}>{ shortenLabelName(h)}</th> )
    }
  }
  return (
    <div className="overflow-x-scroll">
      <table className="table-auto text-sm border border-solid border-black" style={{minWidth: "70rem", borderSpacing: "0px 0px"}}>
        <thead>
          <tr>
            {HeaderParent(json)}
          </tr>
          <tr>
            {HeaderChildren(json)}
          </tr>
        </thead>
        <tbody>
            {
              json.datasets.map((row) => {
                return (
                  <tr>
                    {
                      row.map((val, i) => {
                        if (i < 2) {
                          const widthClass = i === 0 ? "w-36" : "w-28"
                          return <td className={`border border-solid px-1 py-2 text-right ${widthClass}`} key={val + i.toString()}>{fixDigit(val, i)}</td>
                        } else {
                          const maxScore = 8
                          return (
                            <td className="border border-solid px-0 py-0.5 text-right text-xs lg:text-sm w-24" key={val + i.toString()}>
                              <div className="w-1/2 h-6 float-left">
                                <div className={`bg-main-blue-100 h-6`} style={{width: (parseFloat(val) / maxScore * 100 * 2).toString() + '%'}}></div>
                              </div>
                              <div className="w-1/2 pr-1 float-right">
                                {fixDigit(val, i)}
                              </div>
                            </td>
                          )
                        }
                      })
                    }
                  </tr>
                )
              })
            }
        </tbody>
      </table>
    </div>
  )
}

export default Table;